<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data ProductionQualityInspectionVisualDetail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="workOrderExecutionNgs" optionsLabel="workOrderExecutionDetail" optionsKey="id" label-cols-lg="12" label="Work Order Execution Ng" id="input-" size="sm" :model.sync="model.workOrderExecutionNgId"   :selected="model.workOrderExecutionNg != null ? model.workOrderExecutionNg.workOrderExecutionDetail : ''" @input="getWorkOrderExecutionNgs" />
				<app-input-combobox-autocomplete :options="problemCategorys" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Ng Category" id="input-" size="sm" :model.sync="model.problemCategoryId"   :selected="model.problemCategory != null ? model.problemCategory.code : ''" @input="getProblemCategorys" />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-ng-qty" label-cols-lg="12" label="Ng Qty" label-for="input-ng-qty" size="sm" :model.sync="model.ngQty"  />

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ProductionQualityInspectionVisualDetail from '@/models/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualDetail';
import ProductionQualityInspectionVisualDetailFilter from '@/filters/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualDetailFilter';

import ProductionQualityInspectionVisual from '@/models/ProductionQualityInspectionVisual/ProductionQualityInspectionVisual';
import ProductionQualityInspectionVisualFilter from '@/filters/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderExecutionNg from '@/models/WorkOrderExecutionNg/WorkOrderExecutionNg';
import WorkOrderExecutionNgFilter from '@/filters/WorkOrderExecutionNg/WorkOrderExecutionNgFilter';
import ProblemCategory from '@/models/ProblemCategory/ProblemCategory';
import ProblemCategoryFilter from '@/filters/ProblemCategory/ProblemCategoryFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
			},
			workOrderExecutionNgs : [],
			problemCategorys : [],
			isBusy: false,
		}
	},
	methods : {
		getProductionQualityInspectionVisualDetail : async function(id) {
			this.isBusy = true;
			ProductionQualityInspectionVisualDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getWorkOrderExecutionNgs : async function(input) {
			let filter = new WorkOrderExecutionNgFilter();
			if (input != undefined) {
				filter.workOrderExecutionDetail = input;
			}
			WorkOrderExecutionNg.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutionNgs = result.data
				}
			})
			.catch(error => {});
		},
		getProblemCategorys : async function(input) {
			let filter = new ProblemCategoryFilter();
			if (input != undefined) {
				filter.code = input;
			}
			ProblemCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.problemCategorys = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getWorkOrderExecutionNgs();
		//this.getProblemCategorys();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getProductionQualityInspectionVisualDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getWorkOrderExecutionNgs();
				this.getProblemCategorys();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getProductionQualityInspectionVisualDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
